import { InputNumberProps, InputProps } from '@easyv/react-components';
import * as React from 'react';
import { ProInputNumber } from '.';

interface ProInputEulerNumberProps
  extends Omit<
    InputNumberProps,
    'onChange' | 'value' | 'onBlur' | 'onPointMoveStart' | 'onPointMoveEnd'
  > {
  precisionOnShow?: number;
  precisionOnSave?: number;
  name: string;
  value: number;
  min?: number;
  max?: number;
  onChange?: (name: string, value: number) => void;
  onBlur: (name: string, value: number) => void;
}

export const ProInputEulerNumber: React.FC<ProInputEulerNumberProps> = (props) => {
  const {
    name,
    value,
    suffix = '°',
    onBlur,
    onChange,

    ...rest
  } = props;

  const realToInputValue = React.useCallback((value: number) => {
    return (value / Math.PI) * 180;
  }, []);

  const inputToRealValue = React.useCallback((value: number) => {
    return (value * Math.PI) / 180;
  }, []);

  return (
    <ProInputNumber
      name={name}
      value={value}
      suffix={suffix}
      onBlur={onBlur}
      onChange={onChange}
      realToInputValue={realToInputValue}
      inputToRealValue={inputToRealValue}
      {...rest}
    />
  );
};
